import { render, staticRenderFns } from "./menu__form.vue?vue&type=template&id=314c39c0"
import script from "./menu__form.vue?vue&type=script&lang=js"
export * from "./menu__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports